interface FullPageStatusProps {
  message: string;
}

/** Centred status message used while auth/onboarding checks resolve. */
export function FullPageStatus({ message }: FullPageStatusProps) {
  return (
    <div className="full-page-status" role="status" aria-live="polite">
      <span className="full-page-status__text">{message}</span>
    </div>
  );
}
